import { connect } from 'react-redux';
import { IContentPackItem } from '@sitegen/common/types';

import RedemptionSuccess from './redemption-success.component';
import { State } from 'widgets/redeem/root/root.reducers';

const mapStateToProps = (state: State) => ({
    contentPackItems: (state.config.contentPackItems ?? []).filter((item: IContentPackItem) => !item.hidden),
    unlockedContent: state.redemption?.unlockedContent,
    platform: state.redemption?.redeemData?.platform,
    widgetName: state.config.widgetName
});

const RedemptionSuccessContainer = connect(mapStateToProps)(RedemptionSuccess);
export default RedemptionSuccessContainer;
